<template>
    <div>
        <highcharts :options="config"></highcharts>
    </div>
</template>
<script>
    import {deepMerge} from "../../helpers/deepMerge";

    export default {
        props: {
            options: {
                type: Object,
                default() {
                    return {};
                }
            }
        },
        mounted() {
            this.$emit('init');
        },
        name: 'column-chart',
        computed: {
            config() {
                return deepMerge({
                    chart: {
                        spacingLeft: 0,
                        spacingRight: 0,
                        spacingBottom: 0,
                        type: 'column',
                        height: 400,
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        title: {
                            text: null
                        },
                    },
                    yAxis: {
                        title: {
                            text: '',
                        },
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        },
                    },
                    series: []
                }, this.options);
            }
        },
    }
</script>
